// extracted by mini-css-extract-plugin
export default {"products":"Ut-z","card":"Vt-z","oosMessaging":"Wt-z"};